function quoteCompare(item1: any, item2: any, instance: any) {
  if (item1 === null || item2 === null) {
    return false; //unable to compare
  }
  if (item1 instanceof Array && item2 instanceof Array) {
    //deep check
    if (item1.length !== item2.length) {
      return false;
    }
    if (instance.compareKeys.length) {
      let match = 0;
      item1.map((tmp1: any) => {
        const diff1 = item2.find((tmp2: any) => {
          const diff2 = instance.compareKeys.find((key: any) => {
            return tmp1[key] !== tmp2[key];
          });
          return diff2 === undefined; //found perfect match
        });
        if (diff1 !== undefined) {
          match++;
        }
      });

      return match === (item1 as Array<any>).length;
    }
    return true;
  } else if (typeof item1 === 'object' && typeof item2 === 'object' && instance.compareKeys.length) {
    //compare based on keys
    const found = instance.compareKeys.find((key: string) => {
      if (item1[key] instanceof Array && item2[key] instanceof Array) {
        return !compareArray(item1[key], item2[key]);
      } else if (typeof item1[key] === 'object' && typeof item2[key] === 'object') {
        return differentObject(item1[key], item2[key]);
      } else {
        return item1[key] !== item2[key];
      }
    });
    return found === undefined;
  } else {
    throw Error('TermsItem::compare unknown type of value');
  }
}

function differentObject(item1: any, item2: any) {
  if (!item1 && !item2) {
    return false;
  } else if (!item1) {
    return true;
  }

  const result = Object.keys(item1).find((key) => {
    return key in item2 === false || item1[key] !== item2[key];
  });
  return result !== undefined;
}

function compareArray(array1: Array<any>, array2: Array<any>) {
  if (array1.length !== array2.length) {
    return false;
  }
  if (array1.length === 0 && array2.length === 0) {
    return true;
  }

  //presume array contains same datatype
  if (typeof array1[0] === 'object' && typeof array2[0] === 'object') {
    const tmp1 = [...array1];
    const tmp2 = [...array2];
    const index = 0;
    while (tmp1.length) {
      const found = tmp2.find((target) => {
        const iterateResult = Object.keys(tmp1[index]).find((key) => {
          tmp1[index][key] !== target[key];
        });
        return iterateResult === undefined;
      });
      if (found === undefined) {
        return false;
      } else {
        tmp1.splice(index, 1);
        tmp2.splice(tmp2.indexOf(found), 1);
      }
    }
    return true;
  } else {
    const tmp1 = [...array1];
    const tmp2 = [...array2];
    const index = 0;
    while (tmp1.length) {
      const found = tmp2.find((target) => {
        return target === tmp1[index];
      });
      if (found === undefined) {
        return false;
      } else {
        tmp1.splice(index, 1);
        tmp2.splice(tmp2.indexOf(found), 1);
      }
    }
    return true;
  }
}

// function differentDate(item1, item2) {
//   if (!item1 || !item2) {
//     return true;
//   } else if (item1 === item2) {
//     return false;
//   }
//   const item1ToDate = new Date(item1);
//   const item2ToDate = new Date(item2);
//   if (isEqual(item1ToDate, item2ToDate)) {
//     return false;
//   }
//   return !isBefore(item1ToDate, item2ToDate);
// }

export default quoteCompare;
